import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { catservice } from "./productcatService";

export const fetchCategories = createAsyncThunk('categories/fetchAll', async () => {
  const response = await catservice.categorylist();
  return response;
});

// Fetch Category Products
export const fetchCategoryProducts = createAsyncThunk(
  "categories/fetchCategoryProducts",
  async ({ category, subCategory }) => {
    const response = await catservice.categoryandsublist(category, subCategory);
    return response;
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    items: [],  // Make sure 'items' is always an array
    categoryProducts: [],  // Ensure it's an array
    isLoading: false,
    isError: false,
    message: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload || [];  // Fallback to empty array if payload is undefined
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error.message;
      })
      .addCase(fetchCategoryProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryProducts = Array.isArray(action.payload) ? action.payload : [];  // Ensure it's always an array
      })
      .addCase(fetchCategoryProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error.message;
      });
  },
});

export default categorySlice.reducer;
